/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronRightAboveDoubleLine: {
  name: 'chevron-right-above-double-line';
  data: string;
} = {
  name: 'chevron-right-above-double-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.646 9.354a.5.5 0 0 1 0-.708L9.293 5 5.646 1.354a.5.5 0 1 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708 0ZM3.5 12a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1H4Z" fill="currentColor"/></svg>`,
};
